export default __webpack_public_path__ + "static/media/android-btn.da1d46e0.png";